import { request } from "@/utils";
import api from "./index";
import moment from "moment";
// 顧客身份相關api
const customerApi = {
  /** 綁定業者
   * inviteCode: 邀請碼
   */
  bindServiceProvider: async (inviteCode) => {
    try {
      const res = await api.post(`/private/binding/${inviteCode}`);
      return res;
    } catch (error) {
      console.error("Error in customerApi.bindServiceProvider:", error);
      throw error;
    }
  },
  /** 取得已綁定的service provider */
  getBindServiceProvider: async () => {
    try {
      const res = await api.get(`/private/binding/providers`);
      return res;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  /** 取得使用者service provider的狀態(申請中/已通過) */
  getServiceProviderStatus: async () => {
    try {
      const res = await api.get(`/private/identity/applications/my`);
      return res;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  /** 取得使用者organization的狀態(申請中/已通過) */
  getOrganizationStatus: async () => {
    try {
      const res = await api.get(`/private/user/organizations`);
      return res;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  /** 取得使用者已通過的service provider 身份 */
  getServiceProviderIdentity: async () => {
    try {
      const res = await api.get(`/private/user/identities`);
      return res;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  /**取得顧客訂單 */
  getCustomerOrder: async (
    startDate,
    //預設為3個月後
    endDate = moment().add(3, "months").format("YYYY-MM-DD"),
    limit = 999,
    offset = 0,
  ) => {
    try {
      const res = await api.get(`/private/order/asUser/bookingOrder`, {
        params: {
          from_date: startDate,
          end_date: endDate,
          limit,
          offset,
        },
      });
      return res;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  /**取得顧客訂單by product type */
  getCustomerOrderByProductType: async (
    productType,
    startDate,
    //預設為3個月後
    endDate = moment().add(3, "months").format("YYYY-MM-DD"),
    limit = 999,
    offset = 0,
  ) => {
    try {
      const res = await api.get(`/private/order/asUser`, {
        params: {
          from_date: startDate,
          end_date: endDate,
          limit,
          offset,
          product_type: productType,
        },
      });
      return res;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  /** 顧客取消訂單 */
  cancelCustomerOrder: async (orderId) => {
    try {
      const res = await api.post(`/private/order/cancel/${orderId}/byUser`);
      return res;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  // ------------------------------------------------------------
  /** 自動綁定 */
  autoBindService: async (bindUrl) => {
    // 用bindUrl 作為axios的url，不使用baseURL
    const res = await request.post(bindUrl);
    return res;
  },

  /** 取得預約紀錄 */
  getAppointmentList: async (userId, startDate, endDate) => {
    try {
      const res = await request.get(`/api/user/${userId}/appointments`, {
        params: {
          start_date: startDate,
          end_date: endDate,
        },
      });
      return res;
    } catch (error) {
      console.error("Error in customerApi.getAppointmentList:", error);
      throw error;
    }
  },

  /** 取得用戶筆記 */
  getUserNotes: async (keyword) => {
    try {
      const res = await api.get("/private/user/notes", {
        params: {
          keyword,
        },
      });
      return res;
    } catch (error) {
      console.error("Error in customerApi.getUserNotes:", error);
      throw error;
    }
  },

  /** 創建用戶筆記 */
  createUserNote: async (noteData) => {
    try {
      const res = await api.post("/private/user/note", noteData);
      return res;
    } catch (error) {
      console.error("Error in customerApi.createUserNote:", error);
      throw error;
    }
  },

  /** 刪除用戶筆記 */
  deleteUserNote: async (noteId) => {
    try {
      const res = await api.delete(`/private/user/note/${noteId}`);
      return res;
    } catch (error) {
      console.error("Error in customerApi.deleteUserNote:", error);
      throw error;
    }
  },

  /** 取得單一訂單資訊 */
  getOrderDetail: async (orderId) => {
    try {
      const res = await api.get(`/private/order/asUser/${orderId}`);
      return res;
    } catch (error) {
      console.error("Error in customerApi.getOrderDetail:", error);
      throw error;
    }
  },
};

export default customerApi;
